import React, { useState, useEffect } from "react";
import "./Leadership.css";
const leadershipBanner = process.env.PUBLIC_URL + '/images/ecosystem/whymsbnr.jpg';
const Leadership = () => {
  const [leadershipData, setLeadershipData] = useState({
    leadership: {},
    teams: []
  });
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    //console.log("Leadership API calling...");
    fetch(`${process.env.REACT_APP_API_URL}/leadership-page`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-username": process.env.REACT_APP_API_URL_USERNAME,
        "api-password": process.env.REACT_APP_API_URL_PASSWORD
      },
      body: JSON.stringify({})
    })
      .then((response) => {
        console.log("API Status:", response.status);
        return response.json();
      })
      .then((data) => {
        console.log("Leadership API Response:", data);
        setLeadershipData(data);
      })
      .catch((error) => {
        console.log("API Error:", error);
      }).finally(() => {
        setLoading(false);
      });
  }, []);
  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }
  return (
    <div className="leadership-page">
      {/* Banner Section */}
      <section className="leadership-banner inner-page-banner" style={{ backgroundImage: `url(${leadershipBanner})` }}>
        <div className="leadership-banner-overlay inner-page-banner-overlay" />
        <div className="container leadership-banner-inner inner-page-banner-inner">
          <h1 className="inner-page-banner-title">Leadership</h1>

        </div>
      </section>

      <div className="inner-page-breadcrumb-wrap">
        <div className="container">
          <nav className="inner-page-breadcrumb">
            <a className="inner-page-home" href="/">Home</a>
            <span className="inner-page-sep"><i className="bi bi-chevron-right" /></span>
            <span className="inner-page-current">Leadership</span>
          </nav>
        </div>
      </div>

      {/* Intro Section */}
      <section className="leadership-intro-section">
        <div className="container">
          <div className="leadership-intro" data-aos="fade-up">
            <h2 className="leadership-heading">Leadership Built Around Transformation, Innovation, and Enterprise Excellence</h2>
            <p className="leadership-subtext">
              Our leadership team brings together deep expertise across SAP transformation, enterprise technology, finance modernization, AI platforms, cybersecurity, and global delivery operations. With experience spanning consulting, enterprise systems, cloud platforms, analytics, and operational strategy, our leaders help organizations navigate transformation with clarity, discipline, and long-term vision.
            </p>
          </div>
        </div>
      </section>

      {/* Featured Profile Section */}
      <section className="leadership-featured-section">
        <div className="container">
          <div className="leadership-featured">
            <div
              dangerouslySetInnerHTML={{
                __html: leadershipData.leadership.description || ""
              }}
            />
          </div>
        </div>
      </section>
      {/* Team Section */}
      <section className="leadership-team-section">
        <div className="container">
          <div className="leadership-team">
            <h2>Executive Leadership Team</h2>
            <div className="leadership-team-grid">
              {leadershipData.teams.map((profile, idx) => (
                <article className="leadership-team-card" key={idx}>
                  <div className="leadership-card-avatar-wrap">
                    {profile.image ? (
                      <img
                        src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${profile.folder_path}/${profile.image}`}
                        alt={profile.name}
                        className="leadership-card-avatar"
                      />
                    ) : (
                      <div className="leadership-card-initials" aria-hidden="true">
                        {profile.name}
                      </div>
                    )}
                  </div>
                  <div className="leadership-card-details">
                    <h3>{profile.name}</h3>
                    <h4>{profile.designation}</h4>
                    <p>{profile.short_description}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Leadership;